<div class="d-flex align-items-center w-100" style="gap: 10px">
  <p
    class="m-0 ff-poppins-semibold cursor-pointer"
    (click)="toggleLanguage()"
    (keyup.enter)="toggleLanguage()"
    *ngIf="hasLanguage"
    [ngStyle]="{ color: isAuth() ? '#fff' : '' }"
  >
    {{ currentLang === 'en' ? 'EN' : 'AR' }}
  </p>
  <div class="d-flex align-items-center" *ngIf="hasThemes">
    <img
      src="icons/ic_light_mode.svg"
      alt="Light Mode"
      *ngIf="isDarkMode"
      style="filter: invert(1)"
      width="16px"
      height="16px"
      class="cursor-pointer"
      (click)="toggleThemeMode()"
      (keyup.enter)="toggleThemeMode()"
    />
    <img
      src="icons/ic_dark_mode.svg"
      alt="Dark Mode"
      *ngIf="!isDarkMode"
      width="16px"
      height="16px"
      class="cursor-pointer theme-icon"
      (click)="toggleThemeMode()"
      (keyup.enter)="toggleThemeMode()"
      [ngStyle]="{ filter: isAuth() ? 'invert(1)' : '' }"
    />
  </div>
</div>
